import React from 'react';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import moment from 'moment';
import { mustBeArray } from '../../utils/lib';
import { getClientRequestStatusLabel } from '../../utils/clientRequest';

const StatusHistoryList = ({ statusHistory }) => {
  const history = mustBeArray(statusHistory);

  const columns = [
    {
      id: 'changedDate',
      Header: 'Date',
      accessor: c => moment(c.changedDate).format('DD/MM/YYYY h:mm:ss a'),
      maxWidth: 175,
    },
    {
      id: 'fromStatus',
      Header: 'From',
      accessor: c => c.oldStatusId
        ? getClientRequestStatusLabel({statusId: c.oldStatusId, fallbackName: c.oldStatusName})
        : '-',
    },
    {
      id: 'toStatus',
      Header: 'To',
      accessor: c => getClientRequestStatusLabel({statusId: c.newStatusId, fallbackName: c.newStatusName}),
    },
    {
      id: 'changedBy',
      Header: 'Changed By',
      accessor: c => c.changedBy || 'System',
    },
  ];

  return (
    <ReactTable
      sortable
      filterable={false}
      showPagination={history.length > 5}
      data={history}
      columns={columns}
      minRows={Math.min(history.length, 3) || 1}
      defaultPageSize={5}
      defaultSorted={[{id: 'changedDate', desc: true}]}
    />
  );
};

export default StatusHistoryList;
